import yup from '#schema/locale';
import PeOnboardingSchemaPage1 from './PeOnboardingSchemaPage1';
import PeOnboardingSchemaPage2 from './PeOnboardingSchemaPage2';
import PeOnboardingSchemaPage3 from './PeOnboardingSchemaPage3';

const PeOnboardingSchema = yup.object({
  page1: PeOnboardingSchemaPage1,
  page2: PeOnboardingSchemaPage2,
  page3: PeOnboardingSchemaPage3,
});

export { PeOnboardingSchema };
